module.exports = __webpack_public_path__ + "static/media/img-4.0ec923fc.jpg";